/** Animate numeric counters once they enter the viewport. */
export function initCountUp(scope = document) {
  const counters = scope.querySelectorAll('[data-count]');
  if (!counters.length) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const observer =
    !reduced && 'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              animate(entry.target);
            });
          },
          { threshold: 0.6 }
        )
      : null;

  counters.forEach((element) => {
    if (element.dataset.countReady) return;
    element.dataset.countReady = 'true';
    const end = Number(element.dataset.count);
    if (!Number.isFinite(end)) return;
    if (observer) observer.observe(element);
    else element.textContent = String(end);
  });
}

function animate(element) {
  const end = Number(element.dataset.count);
  const start = performance.now();
  const tick = (now) => {
    const progress = Math.min(1, (now - start) / 1400);
    element.textContent = String(
      Math.round(end * (1 - Math.pow(1 - progress, 4)))
    );
    if (progress < 1) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
}
